export default __webpack_public_path__ + "static/copeland-676d69422c288d80e0d0418002a95b54.jpg";